'use client';

import { useAnalyticsContext } from '../model';

const useAnalytics = () => {
  const { track, identify } = useAnalyticsContext();

  return {
    track,
    identify,
  };
};

export default useAnalytics;
